/**
 * Environment/API URL constants only. Kept in a separate file to avoid circular
 * dependencies (Api.js needs BASE_URL without pulling in Common.js → util.js → Api.js).
 */
export const BASE_URL =
  process.env.REACT_APP_ENV === 'production' ? 'https://api.unique.diamonds' : 'https://betapi.unique.diamonds';
  // 'http://192.168.1.13:8094';
  // 'http://localhost:8094';
  // 'https://0g5xcstt-8094.inc1.devtunnels.ms'
export const BASE_DOWNLOAD_URL = `${BASE_URL}/data`;
export const BASE_URL_ATTACH = BASE_URL;
